import { render, staticRenderFns } from "./music-list.vue?vue&type=template&id=fe13d3bc&scoped=true"
import script from "./music-list.vue?vue&type=script&lang=js"
export * from "./music-list.vue?vue&type=script&lang=js"
import style0 from "./music-list.vue?vue&type=style&index=0&id=fe13d3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe13d3bc",
  null
  
)

export default component.exports